/*
* This script handles the changing of postal code for any weather widget. 
* It validates that the postal code is either a US or Canadian postal code, then executes a page refresh, 
* using unpoly if unpoly is detected, otherwise using a regulat location.href change
*/
//Weather zip field changer
const ZIP_FORM_SELECTOR = 'form.postal-code-form';
const ZIP_FORM_INITIALIZED_FLAG = 'data-zip-form-initialized';
// Regex for US (5-digit or 5+4) and Canadian (A1A 1A1 or A1A1A1) postal codes
const POSTAL_CODE_REGEX = /^(\d{5}(?:-\d{4})?|[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z] ?\d[ABCEGHJ-NPRSTV-Z]\d)$/i;
const unpolyLocation = false;

// --- Main execution logic for the loader script---
if (window.up && window.up.version && unpolyLocation) {
     up.compiler(ZIP_FORM_SELECTOR, function(formElement) {
        if (formElement.hasAttribute(ZIP_FORM_INITIALIZED_FLAG)) {
            //console.log(`Zip form ${formElement.id || formElement.className} already initialized by Unpoly compiler.`);
            return;
        }
        initializeZipForm(formElement);
        formElement.setAttribute(ZIP_FORM_INITIALIZED_FLAG,'true');
    });

} else {
    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll(ZIP_FORM_SELECTOR).forEach(formElement => {
            if (formElement.hasAttribute(ZIP_FORM_INITIALIZED_FLAG)) {
                //console.log(`Zip form ${formElement.id || formElement.className} already initialized by DOMContentLoaded.`);
                return;
            }
            initializeZipForm(formElement);
            formElement.setAttribute(ZIP_FORM_INITIALIZED_FLAG,'true');
        });
    });
}

function initializeZipForm(formElement) {
    const editButton = formElement.querySelector('.edit-zip-button');
    const submitButton = formElement.querySelector('.submit-zip-button');
    const zipcodeEditor = formElement.querySelector('.zipcode-editor'); 
    const zipcodeDisplay = formElement.querySelector('.zipcode-display'); 

    // Ensure all required elements are found
    if (!editButton || !submitButton || !zipcodeDisplay || !zipcodeEditor) {
        return;
    }

    // --- Initial State Setup (Ensures correct visibility on load) ---
    zipcodeEditor.style.display = 'none';
    zipcodeDisplay.style.display = 'inline-block'; 
    submitButton.style.display = 'none'; // Hide submit button initially

    editButton.addEventListener('click', (event) => {
        event.preventDefault();
        // Copy value from span to input, removing parentheses
        const originalText = zipcodeDisplay.textContent;
        const cleanedZipcode = originalText.replace(/[()]/g, '');
        zipcodeEditor.value = cleanedZipcode;

        // Toggle display
        zipcodeDisplay.style.display = 'none'; 
        zipcodeEditor.style.display = 'inline-block'; 
        zipcodeEditor.focus(); 
        editButton.style.display = 'none';
        submitButton.style.display = 'inline-block';

        // Clear any previous validation messages when editing
        zipcodeEditor.setCustomValidity('');
    });
    
    // Add keydown listener to the zipcode-editor field
    zipcodeEditor.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
            event.preventDefault(); // Prevent default form submission if any
            zipcodeEditor.blur(); 
            setTimeout(() => {
                handleZipSubmit();
            }, 0);
        }
    });
    
    submitButton.addEventListener('click', (event) => {
        event.preventDefault(); // Prevent default form submission if any
        handleZipSubmit();
    });
    
    function handleZipSubmit(){
        const zipValue = zipcodeEditor.value.trim(); // Get the current value from the input, trimmed of whitespace

        // --- Validation Logic ---
        zipcodeEditor.setCustomValidity('');

        if (!zipValue) {
            // If the value is empty or just whitespace
            zipcodeEditor.setCustomValidity("Please enter a valid US or Canadian postal code.");
            zipcodeEditor.reportValidity(); 
            return; 
        }

        // Test against the regex for US/Canadian postal codes
        if (!POSTAL_CODE_REGEX.test(zipValue)) {
            zipcodeEditor.setCustomValidity("Please enter a valid US or Canadian postal code.");
            zipcodeEditor.reportValidity();
            return; 
        }

        // Construct the new URL with the 'weather_zip' parameter
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('weather_zip', zipValue);
        const newUrl = currentUrl.toString();

        // Trigger Unpoly page load to the new URL
        if (window.up && window.up.navigate && unpolyLocation) {
            up.navigate({
                url: newUrl,
                target: 'up-main', //need to enjoy this is correct for our final pages
                save: true
            })
            .then(() => {
                // Revert UI state back to "display" mode after successful navigation
                zipcodeDisplay.style.display = 'inline-block'; 
                zipcodeEditor.style.display = 'none'; 
                editButton.style.display = 'inline-block'; 
                submitButton.style.display = 'none'; 
            })
            .catch(error => {
                // Handle navigation errors
            });
        } else {
            window.location.href = newUrl;
        }
    
    }
}